module.exports = __webpack_public_path__ + "img/banner.f9d16494.png";